import Tailors from './Tailors';

export default Tailors;
